export default __webpack_public_path__ + "static/media/DV_nadrz.7350b55e.jpg";